import { useEffect, useState } from "react";

import { getFunctionalityData } from "@api/functionalityData";

export const useFunctionalityData = (service: any) => {
  const [data, setData] = useState<any>([]);

  useEffect(() => {
    if (service) {
      getFunctionalityData(service)
        .then((data) => setData(data.data))
        .catch((err) => console.log(err));
    }

    return setData([]);
  }, [service]);

  return {
    data,
  };
};
